import { ActionNode, AutomationTaskNode, FlowNode } from "../types/nodes";

/**
 * - Adding task attached to the action add it in the first
 * - Adding task in between add it after the source task index
 */
export function getUpdatedActionTasks(options: {
  sourceNode: FlowNode;
  actionNode: ActionNode;
  task: AutomationTaskNode;
}) {
  const { sourceNode, actionNode, task } = options;

  const tasks = actionNode.data?.tasks || [];

  if (sourceNode.type === "action") return [task, ...tasks];

  const taskIndex = tasks.findIndex((task) => task.reference === sourceNode.id);
  const newTaskIndex = taskIndex + 1;
  return [...tasks.slice(0, newTaskIndex), task, ...tasks.slice(newTaskIndex)];
}
